<template>
  <div class="content-box">
    <div class="tab-menus" v-show="tabData.length > 0">
      <el-popover
        placement="bottom"
        width="240"
        trigger="click"
        v-model="isShowTabSearch"
      >
        <i slot="reference" class="iconfont icon-caidan-line"></i>
        <div v-outside="outsideEvents" class="popover-content">
          <el-input
            ref="searchInput"
            v-model="tabKeyword"
            :placeholder="$t('tabBar.menuNameSearch')"
            size="mini"
            clearable
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
          <div v-if="tabKeyword" class="search-count">{{ $t('tabBar.searchResultTotal', { count: searchTabData.length }) }}</div>
          <div v-if="!tabKeyword || (tabKeyword && searchTabData.length)" class="popover-content-list">
            <div
              :class="['popover-content-list-item', activeTabKey === item.key ? 'active' : '']"
              v-for="item in searchTabData"
              :key="item.key"
            >
              <span
                @click="cusSelectTab(item)"
                v-html="
                  item.name.replace(
                    tabKeyword,
                    `<span style='color:#0090FF'>${tabKeyword}</span>`
                  )
                "
              >
              </span>
              <i @click="cusRemoveTab(item.key)" class="el-icon-close"></i>
            </div>
          </div>
          <div
            class="wrapper"
            v-else
          >
            <div class="img"></div>
            <span class="tips">{{ $t('tabBar.noData') }}</span>
          </div>
          <el-dropdown class="shortcut-close" @command="handleCommand" placement="bottom-start">
            <div class="shortcut-close-item">
              <span>{{ $t('tabBar.quickCloseTab') }}</span>
              <i class="iconfont el-icon-arrow-right"></i>
            </div>
            <el-dropdown-menu slot="dropdown" class="el-dropdown-menu-box">
              <el-dropdown-item command="current">{{ $t('tabBar.closeCurrentTab') }}</el-dropdown-item>
              <el-dropdown-item command="all">{{ $t('tabBar.closeAllTab') }}</el-dropdown-item>
              <el-dropdown-item command="other">{{ $t('tabBar.closeOtherTab') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-popover>
    </div>
    <!-- 快捷菜单 -->
    <ShortCutMenu/>
    <el-tabs
      type="card"
      class="tabBar"
      v-model="routesss"
      @tab-remove="removeTab"
      @tab-click="tabClick"
    >
      <el-tab-pane
        :key="HOME_PAGE_KEY"
        :label="$t('tabBar.homePage')"
        :name="HOME_PAGE_KEY"
        :closable="false"
        :tabInfo="{ key: HOME_PAGE_KEY }"
      >
        <span slot="label">
          <i :class="['iconfont', 'icon-shouye-line']"></i>
          {{ $t('tabBar.homePage') }}
        </span>
        <template v-if="String(userInfo && userInfo.vccId) === '2004305'">
          <iframe :src="'https://' + customPage + '/homePage'" width="100%" height="100%" frameborder="0" />
        </template>
        <HomeTab v-else />
      </el-tab-pane>
      <el-tab-pane
        lazy
        v-for="item in tabData"
        :key="item.key"
        :label="item.name"
        :name="item.key"
        :closable="item.key !== '0'"
        :tabInfo="item"
      >
        <template v-if="['cc_workbench'].includes(item.key)">
          <span slot="label">{{ $t('tabBar.call') }}</span>
          <CallPopScreenTab />
        </template>
        <template v-else>
          <span slot="label" class="tab-box">
            <i v-if="item.icon" :class="['iconfont', item.icon]"></i>
            <span class="tab-title" :title="item.name">{{ item.name }}</span>
          </span>
          <iframe :id="item.iframeId" :src="item.url" width="100%" height="100%" allow="autoplay;clipboard-read;clipboard-write;camera;microphone" allowfullscreen frameborder="0" />
        </template>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script type="">
import { mapGetters, mapActions } from "vuex";
import HomeTab from '../homeTab'
import CallPopScreenTab from '../callPopScreenTab'
import ShortCutMenu from '../shortCutMenu'

export default {
  name: "tabBar",
  data() {
    return {
      isShowTabSearch: false,
      tabKeyword: ''
    };
  },
  components: {
    HomeTab,
    ShortCutMenu,
    CallPopScreenTab
  },
  computed: {
    ...mapGetters(["activeTabKey", "tabData", "userInfo"]),
    customPage() {
      const { my: { custom_page = '' } = {} } = this._config.URL || {};
      return custom_page;
    },
    HOME_PAGE_KEY() {
      return this._config.HOME_PAGE_KEY
    },
    routesss: {
      get: function () {
        return this.activeTabKey;
      },
      set: function () {},
    },
    searchTabData() {
      if(this.tabKeyword) {
        return this.tabData.filter((item) => item.name.includes(this.tabKeyword.trim()))
      } else {
        return this.tabData
      }
    }
  },
  watch: {
    isShowTabSearch(val, oldVal) {
      if (val && !oldVal) {
        this.$nextTick(_ => {
          this.$refs.searchInput && this.$refs.searchInput.focus();
        });
      }
    },
  },
  methods: {
    ...mapActions(["delTab", "delAllTab", "delOtherTab", "changeActiveTabKey"]),
    selectTab(tabInfo) {
      this.changeActiveTabKey(tabInfo.key);
      this.$nextTick(() => {
        this._Bus.$emit("clickTab", tabInfo);
      });
    },
    tabClick(tab) {
      const { tabInfo = {} } = tab.$attrs || {};
      console.log(tabInfo,'tabInfo')
      this.selectTab(tabInfo)
    },
    cusSelectTab(tabInfo) {
      this.isShowTabSearch = false
      this.selectTab(tabInfo)
    },
    removeTab(targetKey) {
      let delObj = {
        key: targetKey,
      };
      // 提交componentName
      this.delTab(delObj);
    },
    cusRemoveTab(targetKey) {
      this.removeTab(targetKey)
      if(!this.tabData.length) {
        this.isShowTabSearch = false
      }
    },
    handleCommand(type) {
      switch (type) {
        case "current":
          console.log(this.activeTabKey);
          this.cusRemoveTab(this.activeTabKey);
          break;
        case "all":
          this.$confirm(this.$t('tabBar.closeAllConfirm'), this.$t('common.tips'), {
            confirmButtonText: this.$t('tabBar.confirm'),
            cancelButtonText: this.$t('tabBar.cancel'),
            type: "warning",
          })
            .then(() => {
              this.delAllTab();
              if(!this.tabData.length) {
                this.isShowTabSearch = false
              }
            })
            .catch(() => {});

          break;
        case "other":
          this.$confirm(this.$t('tabBar.closeOtherConfirm'), this.$t('common.tips'), {
            confirmButtonText: this.$t('tabBar.confirm'),
            cancelButtonText: this.$t('tabBar.cancel'),
            type: "warning",
          })
            .then(() => {
              this.delOtherTab({ key: this.activeTabKey });
              if(!this.tabData.length) {
                this.isShowTabSearch = false
              }
            })
            .catch(() => {});
          break;

        default:
          break;
      }
    },
    // 点击弹出层外面，关闭弹窗
    outsideEvents(e) {
      this.isShowTabSearch = false;
    }
  },
};
</script>

<style lang="less" scoped>
@import "./index.less";
</style>



// WEBPACK FOOTER //
// src/view/Home/tabBar/index.vue